import { render, staticRenderFns } from "./CheckBoxIcon.vue?vue&type=template&id=0846fa2e"
import script from "./CheckBoxIcon.vue?vue&type=script&lang=ts"
export * from "./CheckBoxIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports